import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/data-not-found.svg'
import _imports_1 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative font-montserrat" }
const _hoisted_2 = {
  key: 1,
  class: "w-full h-screen bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "not_found"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2 font-bold" }, " Tidak ada hasil yang ditemukan ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2" }, " Apa yang anda cari tidak ditemukan atau tidak ada ", -1)
const _hoisted_6 = {
  key: 2,
  class: "w-full h-screen bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "not_found"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2 font-bold" }, " Data tidak ditemukan pada halaman ini ", -1)
const _hoisted_9 = { class: "absolute w-full bottom-0" }
const _hoisted_10 = {
  key: 3,
  class: "w-full h-screen bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-32 mt-8 mx-auto",
  alt: "data_empty"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2" }, " Belum ada bulk upload yang dapat ditampilkan ", -1)
const _hoisted_13 = {
  key: 0,
  class: "loader rounded-full border-2 border-t-2 h-5 w-5 mx-auto"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 4,
  class: "border-t border-gray-lp-200 border-b overflow-y-auto h-screen pb-40 relative"
}
const _hoisted_16 = {
  class: "p-4 bg-white rounded border border-gray-lp-400",
  style: {"box-shadow":"0 0 2px 0.5px #e0e0e0"}
}
const _hoisted_17 = { class: "text-black-lp-300 flex flex-col w-full" }
const _hoisted_18 = {
  class: "w-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Attachment Orginal File ")
const _hoisted_20 = {
  class: "w-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Attachment Failed File ")
const _hoisted_22 = {
  key: 5,
  class: "absolute w-full bottom-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_TableBulkUpload = _resolveComponent("TableBulkUpload")!
  const _component_UploadForm = _resolveComponent("UploadForm")!
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Header, {
        currentRoutes: "Bulk Upload",
        isSearchable: true,
        isSelectType: true,
        isSelectStatus: true,
        isButtonAction: _ctx.isCreateAble,
        placeholder: "Cari nama atau ID aktivitas",
        searchValue: _ctx.activityName,
        searchAction: _ctx.onSearch,
        clearSearch: _ctx.clearSearch,
        typeData: _ctx.typeData,
        statusData: _ctx.statusData,
        onOpenTypeSelect: _ctx.onOpenTypeSelect,
        onCloseTypeSelect: _ctx.onCloseTypeSelect,
        onSelectType: _ctx.onSelectType,
        valueType: _ctx.typeName,
        typeSelect: _ctx.typeSelect,
        onOpenStatusSelect: _ctx.onOpenStatusSelect,
        onCloseStatusSelect: _ctx.onCloseStatusSelect,
        onSelectStatus: _ctx.onSelectStatus,
        valueStatus: _ctx.statusName,
        statusSelect: _ctx.statusSelect,
        isLoading: _ctx.isLoadingListData,
        buttonAction: _ctx.onOpenUpload,
        buttonText: `Upload Berkas`,
        class: "z-20"
      }, null, 8, ["isButtonAction", "searchValue", "searchAction", "clearSearch", "typeData", "statusData", "onOpenTypeSelect", "onCloseTypeSelect", "onSelectType", "valueType", "typeSelect", "onOpenStatusSelect", "onCloseStatusSelect", "onSelectStatus", "valueStatus", "statusSelect", "isLoading", "buttonAction"]),
      _withDirectives(_createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"]), [
        [_vShow, _ctx.isLoadingListData]
      ]),
      (_ctx.isError && !_ctx.isLoadingListData)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.getBulkList
          }, null, 8, ["errorType", "onTryAgain"]))
        : _createCommentVNode("", true),
      (
        _ctx.bulkListData.length === 0 &&
          !_ctx.isLoadingListData &&
          (_ctx.activityName !== `` || _ctx.archiveType !== `` || _ctx.status !== ``)
      )
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (
        _ctx.bulkListData.length === 0 &&
          _ctx.page !== 1 &&
          !_ctx.isLoadingListData &&
          _ctx.activityName === `` &&
          _ctx.archiveType === `` &&
          _ctx.status === ``
      )
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_Pagination, {
                onNext: _ctx.nextPage,
                onPrevious: _ctx.prevPage,
                page: _ctx.page,
                toPage: _ctx.toPage
              }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
            ])
          ]))
        : _createCommentVNode("", true),
      (
        _ctx.bulkListData.length === 0 &&
          !_ctx.isError &&
          _ctx.activityName === `` &&
          _ctx.archiveType === `` &&
          _ctx.status === `` &&
          !_ctx.isLoadingListData &&
          _ctx.page === 1
      )
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createVNode(_component_button_fill, {
              type: "submit",
              onClick: _ctx.onOpenUpload,
              class: "text-white px-12 py-2 mt-4 text-12px xxl:text-14px font-bold rounded-md focus:outline-none bg-red-lp-200 flex flex-row"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoadingListData)
                  ? (_openBlock(), _createBlock("div", _hoisted_13))
                  : _createCommentVNode("", true),
                (!_ctx.isLoadingListData)
                  ? (_openBlock(), _createBlock("span", _hoisted_14, "Upload Berkas Sekarang"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.bulkListData.length !== 0 && !_ctx.isLoadingListData && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode(_component_TableBulkUpload, {
              columns: _ctx.columns,
              data: _ctx.bulkListData,
              class: "my-2",
              onClick: _ctx.toDetail,
              onOpenAttachment: _ctx.setOptionsAttachment,
              isOpenAttachment: _ctx.optionsAttachment,
              clickOutside: _ctx.toOriginal
            }, null, 8, ["columns", "data", "onClick", "onOpenAttachment", "isOpenAttachment", "clickOutside"]),
            (_ctx.optionsAttachment && _ctx.rowData.row === _ctx.rowData.cacheRow)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "text-gray-lp-600 absolute right-0 top-0 hover:bg-red-200 lg:mr-20px xxl:mr-40px",
                  style: 
          `width: 260px; margin-top: ${(_ctx.screenFHD ? 152 : 153) +
            (_ctx.screenFHD ? 87 : 88) * _ctx.rowData.row}px`
        ,
                  onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.optionsAttachment = false))
                }, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", {
                        class: "cursor-pointer flex flex-row items-center font-medium text-gray-lp-300 hover:text-red-lp-100",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toOriginal && _ctx.toOriginal(...args))),
                        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.originalHover = true)),
                        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.originalHover = false))
                      }, [
                        (_openBlock(), _createBlock("svg", _hoisted_18, [
                          _createVNode("path", {
                            fill: _ctx.originalHover ? '#B82025' : '#A7A8AA',
                            "fill-rule": "evenodd",
                            d: "M7 4c-.265 0-.52.105-.707.293C6.105 4.48 6 4.735 6 5v14c0 .265.105.52.293.707.187.188.442.293.707.293h10c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V9.414L12.586 4H7zM4.879 2.879C5.44 2.316 6.204 2 7 2h5.586c.53 0 1.04.21 1.414.586m0 0L19.414 8c.375.375.586.883.586 1.414V19c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879H7c-.796 0-1.559-.316-2.121-.879C4.316 20.56 4 19.796 4 19V5c0-.796.316-1.559.879-2.121M12 9c.552 0 1 .448 1 1v3.586l1.293-1.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-3 3c-.39.39-1.024.39-1.414 0l-3-3c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0L11 13.586V10c0-.552.448-1 1-1z",
                            "clip-rule": "evenodd"
                          }, null, 8, ["fill"])
                        ])),
                        _hoisted_19
                      ], 32),
                      (
                _ctx.isAbleDownloadFailedAttachment(
                  _ctx.rowData.status,
                  !!_ctx.rowData.failedFile
                )
              )
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "pt-4 cursor-pointer flex flex-row items-center font-medium text-gray-lp-300 hover:text-red-lp-100",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toFailed && _ctx.toFailed(...args))),
                            onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.failedHover = true)),
                            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.failedHover = false))
                          }, [
                            (_openBlock(), _createBlock("svg", _hoisted_20, [
                              _createVNode("path", {
                                fill: _ctx.failedHover ? '#B82025' : '#A7A8AA',
                                "fill-rule": "evenodd",
                                d: "M9.402 3.5c1.155-2 4.04-2 5.196 0l6.928 12c1.155 2-.288 4.5-2.598 4.5H5.072c-2.31 0-3.753-2.5-2.598-4.5l6.928-12zm1.732 1l-6.928 12c-.385.666.096 1.5.866 1.5h13.856c.77 0 1.25-.834.866-1.5l-6.928-12c-.385-.666-1.347-.666-1.732 0zM12 8c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1s-1-.448-1-1V9c0-.552.448-1 1-1zm-1 7c0-.552.448-1 1-1h.01c.552 0 1 .448 1 1s-.448 1-1 1H12c-.552 0-1-.448-1-1z",
                                "clip-rule": "evenodd"
                              }, null, 8, ["fill"])
                            ])),
                            _hoisted_21
                          ], 32))
                        : _createCommentVNode("", true),
                      _createVNode("div", {
                        class: "arrow-top absolute z-10 right-0 mr-5",
                        style: `bottom: ${_ctx.rowData.failedFile ? '88' : '50'}px`
                      }, null, 4)
                    ])
                  ])
                ], 36))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.bulkListData.length !== 0 && !_ctx.isLoadingListData && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_22, [
            _createVNode(_component_Pagination, {
              onNext: _ctx.nextPage,
              onPrevious: _ctx.prevPage,
              page: _ctx.page,
              isButtonNext: _ctx.bulkListData.length >= _ctx.limit,
              totalData: _ctx.bulkListData.length,
              toPage: _ctx.toPage
            }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpenUpload)
      ? (_openBlock(), _createBlock(_component_UploadForm, {
          key: 0,
          page: _ctx.page
        }, null, 8, ["page"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Detail, { onClose: _ctx.onCloseDetail }, null, 8, ["onClose"]), [
      [_vShow, _ctx.isOpenDetail]
    ]),
    (_ctx.isErrorUpload && !_ctx.isLoadingListData)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.isErrorCauseUpload,
          onTryAgain: _ctx.handleErrorClose,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true)
  ], 64))
}